import React from "react";
import Frame from "../layout/Frame";
import Meta from "../layout/Meta";
import OutcomesStrip from "../blocks/Outcomes";
import Invite from "../blocks/Invite";

const cases = [
  { code: "OUT.01", brand: "DTC apparel · EU", line: "+312% ROAS, −41% CPA, payback 11 days", note: "Rebuilt Meta + Google bid model and full creative-velocity engine. 4-market geo-holdout confirmed +8.4x incremental lift." },
  { code: "OUT.02", brand: "App marketer · MENA", line: "−54% CPI, +2.6x ROAS on D7", note: "ASA + AppLovin + Meta unified bid against MMP cohort. Creative testing weekly under controlled holdouts." },
  { code: "OUT.03", brand: "FMCG · Türkiye", line: "+182% retail-media ROAS", note: "Trendyol Ads + Hepsiburada Ads + Sponsored Brands re-architected around share-of-shelf. SKU-level profitability instrumentation." },
  { code: "OUT.04", brand: "Fintech · DACH", line: "−28% CAC, payback 19 days", note: "Programmatic display + paid social full audit, creative refresh on 6-week rhythm, lift-tested budget reallocation." },
  { code: "OUT.05", brand: "Travel OTA · Balkans", line: "+62% bookings · 4 markets", note: "Search + paid social repositioning, multi-market creative production, full attribution rebuild in Q1." },
  { code: "OUT.06", brand: "Hotel group · MENA", line: "+88% direct bookings", note: "Programmatic CTV + paid social + meta-search bidding. Conversion-rate optimisation on hotel pages closed the loop." }
];

const Outcomes = () => (
  <Frame>
    <Meta title="Outcomes" description="Verified performance outcomes from recent NTAC engagements — anonymised under NDA." />
    <section className="svc-hero">
      <div className="shell">
        <div className="crumb"><a href="/">Home</a><span className="sep">/</span>Outcomes</div>
        <span className="tag tag--orange">OUTCOMES · UNDER NDA</span>
        <h1 style={{ marginTop: "1.25rem" }}>What wins look like.</h1>
        <p className="lede">
          Every account engagement is bound by confidentiality. The cases below are anonymised — the names and
          identifying detail are removed, the numbers and shape are real.
        </p>
      </div>
    </section>
    <OutcomesStrip />
    <section className="band">
      <div className="shell">
        <div className="services">
          {cases.map((c) => (
            <article key={c.code} className="service" style={{ cursor: "default" }}>
              <div className="num">★</div>
              <div>
                <div className="code">{c.code} · {c.brand}</div>
                <h3>{c.line}</h3>
                <p>{c.note}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
    <Invite
      title="Your account next."
      text="Tell us the spend and the metric. We'll respond with what we think we can verifiably move — and how we'd structure the test."
    />
  </Frame>
);

export default Outcomes;
